nudgeHandler = {};
nudgeHandler.nudgeSymbolAssets = [];

symbolKeys = {
  0: 'Ten',
  1: 'Jack',
  2: 'Queen',
  3: 'King',
  4: 'Ace',
  12: 'PitchFork',
  13: 'GemSack',
  14: 'Notes',
  15: 'Crown',
  16: 'StandardDevil',
  17: 'BoostDevil',
  18: 'MultiDevil',
  19: 'RespinDevil'
}

nudgeHandler.nudgeSymbols = async (nudgeModifier, endSymbol) => {
  const {nudgeSymbols, isUpNudge} = nudgeModifier;

  const reelContainer = resourceManager.get('slotContainer:reelContainer:reel7');
  const landedSymbol = resourceManager.get('slotContainer:reelContainer:reel7:symbol0');

  // set visibile false as we're replacing with duplicated version to nudge
  landedSymbol.visible = false;
  reelContainer.setReelSymbol(0, endSymbol);

  const nudgeSymbolOffset = 176;
  [...nudgeSymbols, endSymbol].forEach((id, i) => {
    const symbolNudgeAsset = resourceManager.createObject(
      'movie',
      `nudgeSymbolID:${id}${i}`,
      reelContainer,
      {
        definition: symbolKeys[id],
        anchor: 0.5,
        loop: false,
        x: 0,
        y: (isUpNudge ? 1 : -1) * nudgeSymbolOffset * i
      }
    );
    symbolNudgeAsset.gotoAndStop(0);
    nudgeHandler.nudgeSymbolAssets.push(symbolNudgeAsset);
  });

  await gameController.devilCharacter.nudge();
  gameController.respinAnticipationSymbolFrames[7].play();
  gameController.respinAnticipationSymbolFrames[7].alpha = 1;

  soundManager.play("middleReelSpin");
  for (let i = 0; i < nudgeSymbols.length; i++) {
    soundManager.play("devilNudge2");
    // loop over each asset but nudge all of them
    await gsap.to(nudgeHandler.nudgeSymbolAssets, {y: `${isUpNudge ? '-' : '+'}=${nudgeSymbolOffset}`, duration: 0.5, delay: i > 0 ? 0.5 : 0 });
  };
  soundManager.stop("middleReelSpin");
  soundManager.play("middleReelStop");

  gameController.devilCharacter.dance(3);

  gameController.respinAnticipationSymbolFrames[7].gotoAndStop(0);
  gsap.to(gameController.respinAnticipationSymbolFrames[7], {alpha: 0, duration: 0.5})

  // RESET \\
  landedSymbol.visible = true;
  // get rid of all of the other symbol that were nudged
  nudgeHandler.nudgeSymbolAssets.forEach((nudgeAsset) => {
    resourceManager.destroyObject(nudgeAsset.name);
  });
  nudgeHandler.nudgeSymbolAssets.length = 0;
};